var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineReturnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.083374C14.1917 0.083374 13.8833 0.237541 13.575 0.391707L1.39583 7.17504C0.933333 7.48337 0.625 7.94587 0.625 8.56254V22.4375C0.625 23.0542 0.933333 23.5167 1.39583 23.825L13.575 30.6084C13.8833 30.7625 14.1917 30.9167 14.5 30.9167C14.8083 30.9167 15.1167 30.7625 15.425 30.6084L16.8125 29.8375C16.35 28.9125 16.1958 27.8334 16.0417 26.7542V16.425L25.2917 11.1834V17.0417C26.3708 17.0417 27.45 17.1959 28.375 17.5042V8.56254C28.375 7.94587 28.0667 7.48337 27.6042 7.17504L15.425 0.391707C15.1167 0.237541 14.8083 0.083374 14.5 0.083374ZM14.5 3.47504L23.75 8.56254L20.6667 10.2584L11.5708 5.01671L14.5 3.47504ZM8.4875 6.71254L17.5833 12.1084L14.5 13.8042L5.25 8.56254L8.4875 6.71254ZM3.70833 11.1834L12.9583 16.425V26.7542L3.70833 21.5125V11.1834ZM28.8375 21.3584L23.2875 26.9084L20.8208 24.4417L19.125 26.2917L23.4417 30.9167L30.8417 23.5167L28.8375 21.3584Z",
    fill: "#62B5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineReturnsIcon);
export default __webpack_public_path__ + "static/media/online-returns-icon.7da7c4ceb9344fbf11fb7ccb680ded1c.svg";
export { ForwardRef as ReactComponent };